const DrawingModes = {
  ERASING: 'ERASING',
  PAINTING: 'PAINTING',
  DELETE: 'DELETE',
  MOVE: 'MOVE'
}

export default DrawingModes
